import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-248243e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper vh-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmsAuthWithPhoneSwitch = _resolveComponent("SmsAuthWithPhoneSwitch")!
  const _component_PhoneAuth = _resolveComponent("PhoneAuth")!
  const _component_ReactivateAccountModal = _resolveComponent("ReactivateAccountModal")!
  const _component_ConfirmBirthDateModal = _resolveComponent("ConfirmBirthDateModal")!
  const _component_ConfirmAccountModal = _resolveComponent("ConfirmAccountModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isSms)
        ? (_openBlock(), _createBlock(_component_SmsAuthWithPhoneSwitch, {
            key: 0,
            title: _ctx.headerTitle,
            phoneNumber: _ctx.phoneNumber,
            createSms: _ctx.createSms,
            validateSms: _ctx.validateSms,
            createPhoneRequest: _ctx.createPhoneRequest,
            onSwitchToVoice: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchProvider('phone'))),
            onValidated: _ctx.onValidated
          }, null, 8, ["title", "phoneNumber", "createSms", "validateSms", "createPhoneRequest", "onValidated"]))
        : (_ctx.isVoice)
          ? (_openBlock(), _createBlock(_component_PhoneAuth, {
              key: 1,
              title: _ctx.headerTitle,
              phoneNumber: _ctx.phoneNumber,
              createPhoneRequest: _ctx.createPhoneRequest,
              validatePhoneRequest: _ctx.validatePhoneRequest,
              onSwitchToSMS: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchProvider('sms'))),
              onValidated: _ctx.onValidated
            }, null, 8, ["title", "phoneNumber", "createPhoneRequest", "validatePhoneRequest", "onValidated"]))
          : _createCommentVNode("", true)
    ]),
    _createTextVNode(),
    _createVNode(_component_ReactivateAccountModal, {
      isShown: _ctx.isShownReactivateAccountModal,
      onOk: _ctx.reactive,
      onClose: _ctx.forceNavigateWelcome
    }, null, 8, ["isShown", "onOk", "onClose"]),
    _createTextVNode(),
    _createVNode(_component_ConfirmBirthDateModal, {
      isShownInputModal: _ctx.isShownBirthDateModal,
      isShownIncorrectModal: _ctx.isShownIncorrectBirthDateModal,
      onOk: _ctx.confirmBirthDate,
      onClose: _ctx.forceNavigateWelcome
    }, null, 8, ["isShownInputModal", "isShownIncorrectModal", "onOk", "onClose"]),
    _createTextVNode(),
    (_ctx.foundUser)
      ? (_openBlock(), _createBlock(_component_ConfirmAccountModal, {
          key: 0,
          isShown: _ctx.isShownConfirmAccountModal,
          user: _ctx.foundUser,
          onOk: _ctx.navigatePasswordSetting,
          onClose: _ctx.forceNavigateWelcome
        }, null, 8, ["isShown", "user", "onOk", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}